import { calendarDay } from '../../../../../../platform/util/calendarTimezone';
import React, { useState, useEffect, useMemo } from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import { format } from 'date-fns';
import RenderDays from '../day/renderDays';
import { useCalendar } from '../calendarContext';
import RenderEventListForMonth from '../month/rederEventListForMonth';
import { calendarSurfaceSx } from '../shared/viewSurface';
import { formatCalendarDate } from '../../../../../../platform/util/calendarSystem';
 
const MonthView = ({ monthDate, openings, showMontHeader = false, showEventDetailsInside = false, showEventDetailsOutside = false, showEventMarker = false, calculateHeight = false, selectedDayOnlyHighlight = false, todayCivil }) => {
    const {
        bookingDatas, 
        displayCalendar = 'gregory', displayClock, displayTimezone,
    } = useCalendar();

    todayCivil = todayCivil || calendarDay(new Date(), displayTimezone);
    const [mHeight, setMHeight] = useState(null);

    // Calculate height only once on mount or if `calculateHeight` changes
    const updateHeight = useMemo(() => {
        if (!calculateHeight) return null;

        const windowHeight = window.innerHeight;
        const calendarHeight = windowHeight;
        return calendarHeight / 6; // Return the row height calculation
    }, [calculateHeight]); // Only update if `calculateHeight` changes

    useEffect(() => {
        if (updateHeight !== null) {
            setMHeight(updateHeight);
        }
    }, [updateHeight]);

    if (!monthDate) return null;

    return (
        <Grid container style={{ width: '100%', minWidth: '200px', flexGrow: 1,  }} >
            <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Paper sx={{
                    ...calendarSurfaceSx,
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    p: 0.5,
                }}>
                    {showMontHeader && <Typography variant="h5" marginBottom={"20px"} style={{ fontWeight: 'bold' }}>
                        {formatCalendarDate(format(monthDate, 'yyyy-MM-dd'), displayCalendar)}
                    </Typography>
                    }

                    {/* Month Days with full event details */}
                    <Grid container sx={{ mt: 0.25 }}>
                        {RenderDays({ month: monthDate, showEventDetailsInside, showEventMarker, mHeight, openings, selectedDayOnlyHighlight, todayCivil })}
                    </Grid>

                    {/* Render the event list for the month */}
                    <div>
                        {showEventDetailsOutside && RenderEventListForMonth(monthDate, bookingDatas, displayCalendar, displayClock)}
                    </div>
                </Paper>
            </Grid>
        </Grid>
    );
};


export default MonthView;
